module.exports = __webpack_public_path__ + "img/fig11.75a2f071.jpg";